import './Home.css';
import React from "react";
import './Blog.css'


class FirstBlog extends React.Component {
    componentDidMount(){
        document.title = "Nitin Patil's First Blog"
    }
    render() {
        return (
            <>
            <section className="blog-title">
                <h3>{this.props.title}</h3>
                <div className="blog-date">{this.props.postDate}</div>
            </section>
            <section className="content">
                
                <section className="post">
                    <p>It's been a long time since I wanted to host my blog. I couldn't give much time to it. But finally, it's here. Major motivation came from
                        <a href="https://blog.codinghorror.com/about-me/" target="_blank" rel="noreferrer"> Jeff Atwoods's</a> <a href="https://blog.codinghorror.com/" target="_blank" rel="noreferrer">coding horror blog</a>.
                    </p>

                    <p>
                    My main agenda with the blog is to share technical stuff concerning  #programming, #cloud, #k8s, #terraform that I have come across, yet to explore along with travel experiences.
                    </p>
                    <p>
                        I have been in the software industry since 2015. Being in the software industry is one of the best things that has happened to me as it has widespread my knowledge and helped me move across continents for work.
                        I am continuously contributing to early-mid stage startups to large organizations.
                        I want to help out newcomers in the software industry for their personal and career growth with mentorship.
                        Don't want to follow the similar roadmap-based patterns that lots of YouTubers promote but rather invest in the skills that individual lacks where his/her interest belongs.
                    </p>
                    <p> If you are in town, don't forget to say Hi or call for coffee☕

                    <br/> Wish me luck!</p>
                </section>
            </section>
            </>
        )
    }
}

export default FirstBlog;